






































































import api from '@/lib/api'
import Vue from 'vue'
import { debounce } from 'lodash';
import { Box } from '@/lib/types';
export default Vue.extend({
    data(){
        return {
            selected: '',
            link: '',
            message: '',
            categories: [] as any[],
            category: '',
            title: '',
            description: '',
            tag_insert: '',
            nothing: false,
            current_file: {} as File,
            thumbnail: undefined as File | undefined,
            tag_results: [] as string[],
            selected_tags: new Set<string>()
        }
    },
    async beforeMount(){

        const response = await api.media.categories.getAllCategoryNames();
        if(response.err){
            return alert("di' a cippi che è successo un casino");
        }

        this.categories = response.ok!.value;

    },  
    methods: { 
        loadThumbnail(){
            document.getElementById('thumb')!.click();
        },
        async createResource(){

            if(!this.title || !this.category) return this.message = "titolo e categoria sono obbligatori";
            const resource_id = new Box<string>("");

            if(this.selected === 'pdf'){
                resource_id.setValue((await this.createPdf())!);
            }else{
                resource_id.setValue((await this.createLink())!);
            }
            
            if(this.thumbnail){

                const stuff = await api.media.resources.getSignedUrl();
                if(stuff.err) return alert("di' a cippi che è successo un casino");

                await fetch(stuff.ok!.value.signed_url, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    body: this.thumbnail
                });

                await api.media.resources.setThumbnail(resource_id.value, stuff.ok!.value.filename);

            }

            this.message = "pogchamp!"

        },
        async createPdf(){
            this.message = "";
            if(!this.current_file.size){
                this.message = "file obbligatorio"
                return null;
            }
            
            const url = await api.media.articles.getSignedUrl();
            if(url.err){                
                alert("Ai' a cippi che è successo un casino");
                return null;
            }

            await fetch(url.ok!.value.url, {
                method: "PUT",
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                body: this.current_file
            });

            const res = await api.media.articles.upload(url.ok!.value.filename, this.title, this.category, this.description, Array.from(this.selected_tags));
            if(res.err){
                alert("di' a cippi che è successo un casino");
                return null;
            }

            return res.ok!.value

        },
        async createLink(){

            this.message = "";
            if(!this.link){
                this.message = "link obbligatorio!"
                return null;
            }

            const response = await api.media.links.add(this.link, this.title, this.category, this.description, Array.from(this.selected_tags));
            if(response.err){
                alert("di' a cippi che è successo un casino");
                return null;
            }
            
            return response.ok!.value

        },
        closeTagsModal(){
            this.tag_results = [];
            this.tag_insert = ''
            this.nothing = false
        },
        async selectTag(name: string){

            this.selected_tags.add(name);
            this.closeTagsModal();

        },  
        async addTag(){
            
            const resp = await api.media.tags.add(this.tag_insert);
            if(resp.err) return alert("di' a cippi che è successo un casino");

            this.selected_tags.add(this.tag_insert);
            this.closeTagsModal();

        },
        setFile(){
            const input = document.getElementById('pdf')! as HTMLInputElement;
            if(!input.files) return;

            this.current_file = input.files[0];
        },
        setThumbnail(){
            const input = document.getElementById('thumb')! as HTMLInputElement;
            if(!input.files) return;

            this.thumbnail = input.files[0];
        },
        loadFile(){
            document.getElementById('pdf')!.click();
        },
        toggleSelected(string: 'pdf' | 'link'){

            this.selected === string ? this.selected = '' : this.selected = string

        },
        search: debounce(async function(this: any){
            
            this.nothing = false
            if((this as any).tag_insert.trim() === ""){
                return (this as any).tag_results = []
            }
            const response = await api.media.tags.search((this as any).tag_insert);
            if(response.err) return alert("di' a cippi che è successo un casino");
            
            (this as any).tag_results = response.ok!.value;
            (this as any).nothing = response.ok!.value.length === 0;

        }, 300)
    }
})
